import { motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';

export default function InsightsModal({ insights, onClose }) {
  if (!insights) return null;
  return (
    <div className="fixed inset-0 bg-black/40 flex items-end sm:items-center justify-center z-50 p-4" onClick={onClose}>
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="bg-white rounded-3xl w-full max-w-md p-6 border-b-4 border-[#E5E5E5]"
        onClick={(e) => e.stopPropagation()}
        data-testid="insights-modal"
      >
        <div className="flex items-center gap-2 mb-3">
          <div className="w-10 h-10 rounded-2xl bg-[#FFC800] flex items-center justify-center border-b-4 border-[#E5B400]">
            <Lightbulb size={20} color="white" strokeWidth={3} />
          </div>
          <h3 className="text-xl font-extrabold">Your coach&apos;s read</h3>
        </div>

        <div className="grid grid-cols-3 gap-2 mb-4">
          <div className="gm-card p-2 text-center">
            <p className="text-2xl font-extrabold text-[#1CB0F6]">{insights.stats?.completion_rate ?? 0}%</p>
            <p className="text-[10px] uppercase font-extrabold text-[#AFAFAF]">Done</p>
          </div>
          <div className="gm-card p-2 text-center">
            <p className="text-2xl font-extrabold text-[#FF8E2C]">{insights.stats?.streak ?? 0}</p>
            <p className="text-[10px] uppercase font-extrabold text-[#AFAFAF]">Streak</p>
          </div>
          <div className="gm-card p-2 text-center">
            <p className="text-2xl font-extrabold text-[#58CC02]">{insights.stats?.completed ?? 0}</p>
            <p className="text-[10px] uppercase font-extrabold text-[#AFAFAF]">Wins</p>
          </div>
        </div>

        <div className="space-y-3">
          <div className="gm-card p-3">
            <p className="text-[10px] uppercase font-extrabold text-[#AFAFAF]">Pattern</p>
            <p className="text-base font-bold mt-1 leading-snug" data-testid="insight-pattern">{insights.pattern}</p>
          </div>
          <div className="gm-card p-3 bg-[#FFFCEF] border-[#FFC800]">
            <p className="text-[10px] uppercase font-extrabold text-[#FFC800]">From your coach</p>
            <p className="text-base font-bold mt-1 leading-snug" data-testid="insight-encouragement">{insights.encouragement}</p>
          </div>
          <div className="gm-card p-3 bg-[#EFF8FF] border-[#1CB0F6]">
            <p className="text-[10px] uppercase font-extrabold text-[#1CB0F6]">Next step</p>
            <p className="text-base font-bold mt-1 leading-snug" data-testid="insight-recommendation">{insights.recommendation}</p>
          </div>
        </div>

        <button onClick={onClose} className="gm-btn gm-btn-primary w-full text-xl py-4 mt-5" data-testid="close-insights">
          Try the next mission
        </button>
      </motion.div>
    </div>
  );
}
